import { alpha, Typography, useTheme } from '@mui/material';

interface PlanNameProps {
  planName: string;
}

function PlanName({ planName }: PlanNameProps) {
  const theme = useTheme();
  return (
    <Typography
      variant="h2"
      color="primary"
      fontWeight="bold"
      mt={2}
      sx={{
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: '4px',
        alignSelf: 'center',
        textAlign: 'center',
      }}
    >
      {planName}
    </Typography>
  );
}

export default PlanName;
